module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_f_erythristic.32e870d8.png";